import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { useModalsDataActions } from '../../../../../hooks/useModalsDataActions';
import { useEffect } from 'react';
import usePropsConstructor from './props/usePropsConstructor';
import { MAIN } from '../../../../../constants/shared/states/names';
import { useAppState, useDisposableModals as useDisposableModalsData } from '../../../../../redux/reducer/content';
import { useOnboarding } from '../../../../../redux/reducer/content';

export default function useDisposableModals() {
  const disposableModals = useDisposableModalsData();
  const state = useAppState();

  const { clearDisposableModals } = useApplicationCallbacks();
  const { addModal } = useModalsDataActions();
  const createProps = usePropsConstructor();
  const { disposableModalsVisible } = useOnboarding();

  const isCanShow = !!disposableModals?.length && state === MAIN && disposableModalsVisible;

  useEffect(() => {
    if (!isCanShow) return;

    const modals = disposableModals.reduce((acc, modalsArray) => {
      const props = createProps(modalsArray);
      if (props) acc.push(props);
      return acc;
    }, []);

    if (modals?.length) {
      modals.forEach(addModal);
      clearDisposableModals();
    }
  }, [disposableModals, isCanShow]);
}
